import React from "react";

export default function VRIcon2({
  size = 70,
  width,
  height,
  ...rest
}: {
  size?: number;
  width?: number;
  height?: number;
  [key: string]: any;
}) {
  return (
    <svg
      {...rest}
      width={width || size}
      height={height || width}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10628_84730)">
        <path
          d="M32.174 40.1275L30.2402 33.6875H28.0527L30.8965 42.4375H33.4515L36.2952 33.6875H34.1077L32.174 40.1275Z"
          fill="#231F20"
        />
        <path
          d="M43.5491 36.6888C43.5491 35.0263 42.2104 33.6875 40.5479 33.6875H37.0479V42.4375H39.0516V39.5587H40.0054L41.6591 42.4375H43.8116L41.9479 39.2262C42.9104 38.7362 43.5579 37.765 43.5579 36.6888H43.5491ZM40.5566 37.8087H39.0604V35.56H40.5566C41.1079 35.56 41.5541 36.05 41.5541 36.6888C41.5541 37.3275 41.1079 37.8175 40.5566 37.8175V37.8087Z"
          fill="#231F20"
        />
        <path
          d="M62.3875 29.75H61.6875V28.5775C61.6875 25.6025 59.2725 23.1875 56.2975 23.1875H53.2525C52.7625 19.9762 49.98 17.5 46.6288 17.5H24.1675C20.8163 17.5 18.0425 19.9762 17.5438 23.1875H14.5863C11.6113 23.1875 9.19629 25.6025 9.19629 28.5775V29.75H8.40879C5.70504 29.75 3.50879 31.9462 3.50879 34.65V41.475C3.50879 44.1787 5.70504 46.375 8.40879 46.375H9.19629V47.5475C9.19629 50.5225 11.6113 52.9375 14.5863 52.9375H56.2975C59.2725 52.9375 61.6875 50.5225 61.6875 47.5475V46.375H62.3875C65.0913 46.375 67.2875 44.1787 67.2875 41.475V34.65C67.2875 31.9462 65.0913 29.75 62.3875 29.75ZM24.1588 20.125H46.62C48.5188 20.125 50.1025 21.4288 50.5575 23.1875H20.2213C20.6763 21.4288 22.26 20.125 24.1588 20.125ZM8.40004 43.75C7.14879 43.75 6.12504 42.7262 6.12504 41.475V34.65C6.12504 33.3988 7.14879 32.375 8.40004 32.375H9.18754V43.75H8.40004ZM59.0625 47.5475C59.0625 49.07 57.82 50.3125 56.2975 50.3125H14.5775C13.055 50.3125 11.8125 49.07 11.8125 47.5475V28.5775C11.8125 27.055 13.055 25.8125 14.5775 25.8125H56.2888C57.8113 25.8125 59.0538 27.055 59.0538 28.5775V29.75V32.375V43.75V46.375V47.5475H59.0625ZM64.6625 41.475C64.6625 42.7262 63.6388 43.75 62.3875 43.75H61.6875V32.375H62.3875C63.6388 32.375 64.6625 33.3988 64.6625 34.65V41.475Z"
          fill="#231F20"
        />
      </g>
      <defs>
        <clipPath id="clip0_10628_84730">
          <rect
            width="63.7875"
            height="35.4375"
            fill="white"
            transform="translate(3.5 17.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
